define(['jquery', 'responsive_table', 'erv_breakpoints'], function ($, ResponsiveTable, erv_breakpoints) {
	var ResponsiveCommon = function () {
		var self = this;
		self.$ervBody = $('#erv-body');
		self.responsiveTable = new ResponsiveTable();

		self.small = erv_breakpoints['small-max-width'];
		self.medium = erv_breakpoints['medium-max-width'];
		self.large = erv_breakpoints['large-min-width'];

		self.removeEventListener = function ($what) {
			$what.find('[data-js="collapsable"]').unbind();
			$what.removeClass('is-expanded');
			$what.removeClass('is-closed');
		}

		self.addEventListener = function ($what) {
			self.removeEventListener($what);

			if ((window.location.href != undefined && window.location.href.indexOf('?') > -1 && window.location.href.indexOf('MultipleProducts') > -1) || 
			            ($what.attr('id') != undefined && $what.attr('id').indexOf('summary') > -1)) {
				$what.addClass('is-closed');
				$what.removeClass('is-expanded');
			} else {
				$what.addClass('is-expanded');
				$what.removeClass('is-closed');
			}

			$what.find('[data-js="collapsable"]').on('click', function (e) {
				e.preventDefault();
				if ($what.hasClass('is-closed')) {
					$what.addClass('is-expanded');
					$what.removeClass('is-closed');
				} else {
					$what.addClass('is-closed');
					$what.removeClass('is-expanded');
				}

				$what[0].scrollIntoView(true);
			});

		}

		self.getOffset = function (el) {
			var error = false;

			if (!el || el.length === 0) {
				error = true;
			}

			var elRect = el[0].getBoundingClientRect();

			if (typeof (elRect) === 'undefined' || elRect == null || error) {
				elRect = { left: 0, top: 0 };
			}

			return {
				left: elRect.left + window.pageXOffset,
				top: elRect.top + window.pageYOffset
			}
		}

        self.getDeviceSize = function () {
			if (!window.matchMedia) {
				return self.large;
			}
			else if (window.matchMedia('only screen and (max-width: ' + self.small + ')').matches) {
				return self.small;
			} else if (window.matchMedia('only screen and (max-width: ' + self.medium + ')').matches) {
				return self.medium;
			} else if (window.matchMedia('only screen and (min-width: ' + self.large + ')').matches) {
				return self.large;
			}
		}

		self.isDeviceSize = function (size) {
			var deviceSize = self.getDeviceSize();

			if (deviceSize == self.small && size === 'small') {
				return true;
			}

			if (deviceSize == self.medium && size === 'medium') {
				return true;
			}

			if (deviceSize == self.large && size === 'large') {
				return true;
			}
		};
	};

	return ResponsiveCommon;
});